import graphql__b3dd5b434b2c412741fb from "./__generated__/OrganizationAppsMenuItemQuery.graphql.ts";
import graphql__a2f4286c9f66c58eb11a from "./__generated__/OrganizationAppsMenuItem_viewer.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import paths from 'paths'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'
import { useNavigate } from 'react-router-dom'

import { OrganizationAppsMenuItem_viewer$key } from './__generated__/OrganizationAppsMenuItem_viewer.graphql'
import { OrganizationAppsMenuItemQuery } from './__generated__/OrganizationAppsMenuItemQuery.graphql'
import { ViewerAppsRefetchQuery } from './__generated__/ViewerAppsRefetchQuery.graphql'
import AppTenantMenuButton from './AppTenantMenuButton'

const query = graphql__b3dd5b434b2c412741fb

const refetchableApps = graphql__a2f4286c9f66c58eb11a

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
  slug: string
}

export default function OrganizationAppsMenuItem({ isOpen, slug }: Props) {
  const { viewer } = useLazyLoadQuery<OrganizationAppsMenuItemQuery>(query, {
    slug,
  })
  const [data, refetch] = useRefetchableFragment<
    ViewerAppsRefetchQuery,
    OrganizationAppsMenuItem_viewer$key
  >(refetchableApps, viewer)

  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
  }, [refetch, isOpen])

  const apps = data?.organization?.apps ?? []

  const { databasesText, isRenamed } = useAppToDatabaseRename()

  return (
    <div className="flex flex-col gap-0.5">
      {apps.length > 0 ? (
        apps.map((orgApp, index) => {
          const redirectTo = paths.app({
            organizationSlug: slug,
            appSlug: orgApp.slug,
            isRenamed,
          })

          return (
            <AppTenantMenuButton
              key={index}
              label={orgApp.name}
              onClick={() => navigate(redirectTo)}
            />
          )
        })
      ) : (
        <AppTenantMenuButton
          disabled
          label={`No organization ${databasesText} found`}
        />
      )}
    </div>
  )
}
